import { accessObjectViaString } from '../../common/functions/helpers';
import api from '../../common/api';


const mutations = {
	setMedia(state, data) {
		console.log("setSiteuser");
		state.siteuser = data;
    console.log("setSiteuser", state.siteuser);
	},
	setSiteuserAccount(state,data) {
		console.log("setSiteuserAccount");
		state.useraccount = data;
    console.log("setSiteuserAccount", state.useraccount);
	},
  apiFailure: (context, err) => {
      // alert("ERROR" + err);
      console.log(err);
  }
};

const actions = {
  loadMediaitem({ commit }, id) {
    console.log("loadMediaitem");
    return api.get('/media/' + id)
            .then((response) => {return response})
            .catch((error) => commit('apiFailure', error));
  },
  loadMediasource({ commit }, id) {
    console.log("loadMediasource");
    return api.get('/mediasource/' + id)
            .then((response) => {return response})
            .catch((error) => commit('apiFailure', error));
  }
};

const getters = {
};

const state = {
  siteuser: {},
  useraccount: {}
};

export default {
  namespaced: true,
  actions,
  getters,
  state,
  mutations,
};



// WEBPACK FOOTER //
// ./src/vuex/modules/media.js